// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"l_","contentFrame":"ma","buttonGroup":"mb","button":"mc","header":"md","text":"me","contentImage":"mf","closeButton":"mh"};